import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, Input, OnInit } from '@angular/core';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-amount-card',
  templateUrl: './amount-card.component.html',
  styleUrls: ['./amount-card.component.scss']
})
export class AmountCardComponent implements OnInit {

  @Input() public goal = 0;
  @Input() public raised = 0;
  @Input() public date;
  @Input() public supporters;
  @Input() public currency;
  @Input() public isFundraiserEnded;
  @Input() public fundraiser: IFundraiser;
  @Input() isPreview = false;
  today = new Date();
  showRaisedAmt: boolean;
  counto;
  beneficiaryName;
  isMobile;

  constructor(
    public vars: VariablesService,
    public util: UtilService
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.beneficiaryName = this.fundraiser?.beneficiaryname?.info_1.split(' ')[0];
    setTimeout(() => { this.showRaisedAmt = true; }, 0);
  }

  ngOnChanges(change) {
    if (!change?.raised?.currentValue && this.isPreview || change?.raised?.currentValue === 0 && this.isPreview) {
      this.raised = 0;
    }
  }

  setAmount(raised: number) {
    return typeof raised !== 'number' ? false : true;
  }
}
